export default __webpack_public_path__ + "static/media/rumours.08737541.jpg";